<template>
  <v-card :width="550" class="filter-menu">
    <v-tabs v-model="filterTab">
      <v-tab class="ml-0" @click="searchType = 'tabSeason'">ช่วงเทศกาล</v-tab>
      <v-tab @click="searchType = 'tabPeriod'">ช่วงวันที่</v-tab>
    </v-tabs>

    <v-tabs-items v-model="filterTab">
      <v-tab-item class="pa-5">
        <v-layout row wrap ma-0>
          <v-flex xs12 sm6 pr-sm-2>
            <p class="subtitle-2 mt-5 mb-2">ปี พ.ศ.</p>
            <v-select
              v-model="yearSelect"
              :items="yearItems"
              no-data-text="ไม่พบข้อมูล"
              label="เลือกปี"
              class="card-border"
              flat
              solo
              hide-details
            ></v-select>
          </v-flex>
          <v-flex xs12 sm6 pl-sm-2>
            <p class="subtitle-2 mt-5 mb-2">เทศกาล</p>
            <v-select
              v-model="eventSelect"
              :items="eventItems"
              item-text="name"
              item-value="id"
              no-data-text="ไม่พบข้อมูล"
              :return-object="true"
              label="เลือกเทศกาล"
              class="card-border"
              flat
              solo
              hide-details
            ></v-select>
          </v-flex>
        </v-layout>
      </v-tab-item>
      <v-tab-item class="pa-5">
        <v-layout row wrap ma-0>
          <v-flex xs12 sm6 pr-sm-2>
            <p class="subtitle-2 mt-5 mb-2">วันที่เริ่มต้น</p>
            <DatePicker
              v-model="startEventDate"
              ref="startEventDate"
              :max="today"
              @input="changeDate(utils.startDateChanged(startEventDate, endEventDate), false)"
              :defaultDate="eventSelect.start_date ? eventSelect.start_date.substr(0, 10) : startEventDate"
            />
          </v-flex>
          <v-flex xs12 sm6 pl-sm-2>
            <p class="subtitle-2 mt-5 mb-2">วันที่สิ้นสุด</p>
            <DatePicker
              v-model="endEventDate"
              ref="endEventDate"
              :max="today"
              @input="changeDate(utils.endDateChanged(startEventDate, endEventDate), false)"
              :defaultDate="eventSelect.end_date ? eventSelect.end_date.substr(0, 10) : endEventDate"
            />
          </v-flex>
          <v-flex xs12 sm6 pr-sm-2>
            <p class="subtitle-2 mt-5 mb-2">เปรียบเทียบกับวันที่เริ่มต้น</p>
            <DatePicker
              v-model="compareStartEventDate"
              ref="compareStartEventDate"
              :max="today"
              @input="changeDate(utils.startDateChanged(compareStartEventDate, compareEndEventDate), true)"
              :defaultDate="eventSelect.compare_start_date ? eventSelect.compare_start_date.substr(0, 10) : compareStartEventDate"
            />
          </v-flex>
          <v-flex xs12 sm6 pl-sm-2>
            <p class="subtitle-2 mt-5 mb-2">เปรียบเทียบกับวันที่สิ้นสุด</p>
            <DatePicker
              v-model="compareEndEventDate"
              ref="compareEndEventDate"
              :max="today"
              @input="changeDate(utils.endDateChanged(compareStartEventDate, compareEndEventDate), true)"
              :defaultDate="eventSelect.compare_end_date ? eventSelect.compare_end_date.substr(0, 10) : compareEndEventDate"
            />
          </v-flex>
          <v-flex xs12 sm6 pr-sm-2 v-show="isAdmin">
            <p class="subtitle-2 mt-5 mb-2">รายงาน ณ วันที่</p>
            <DatePicker v-model="reportDate" :defaultDate="today" />
          </v-flex>
          <v-flex xs12 sm6 pl-sm-2 v-show="isAdmin">
            <p class="subtitle-2 mt-5 mb-2">เวลา</p>
            <TimePicker v-model="reportTime" :defaultTime="nowtime" />
          </v-flex>
          <!-- <v-flex xs12 sm6 pr-sm-2>
            <p class="subtitle-2 my-2">จังหวัด</p>
            <v-select
              v-model="provinceSelect"
              :items="provinceItems"
              item-text="name"
              item-value="id"
              no-data-text="ไม่พบข้อมูล"
              label="เลือกจังหวัด"
              class="card-border"
              flat
              solo
              hide-details
            ></v-select>
          </v-flex> -->
          <!-- <v-flex xs12 sm6 pl-sm-2>
            <p class="subtitle-2 my-2">ประเภทยานพาหนะ</p>
            <v-select
              v-model="vehicleSelect"
              :items="vehicleItems"
              item-text="name"
              item-value="id"
              no-data-text="ไม่พบข้อมูล"
              label="เลือกยานพาหนะ"
              class="card-border"
              flat
              solo
              hide-details
            ></v-select>
          </v-flex> -->
        </v-layout>
      </v-tab-item>
    </v-tabs-items>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn rounded min-width="120" color="primary" class="mb-5" @click="onSearchClick"
        >ค้นหา</v-btn
      >
    </v-card-actions>
    <v-layout>
      <v-flex class="brightgrey-bg">
        <p class="subtitle-2 my-2 ml-5">{{ filterdate }}</p>
      </v-flex>
    </v-layout>
  </v-card>
</template>

<script>
import DatePicker from '../global/DatePicker.vue';
import TimePicker from '../global/TimePicker.vue';

export default {
  name: 'FilterContent',
  components: { DatePicker, TimePicker },
  data: () => ({
    filterMenu: false,
    filterTab: 0,
    filterdate: '',
    //
    startEventDate: '',
    endEventDate: '',
    compareStartEventDate: '',
    compareEndEventDate: '',
    reportDate: '',
    reportTime: '',
    //
    provinceSelect: '',
    provinceItems: [],
    vehicleSelect: '',
    vehicleItems: [],
    //
    eventSelect: {},
    eventItems: [],
    yearSelect: '',
    yearItems: [],
    today: null,
    nowtime: `${new Date().getHours()}:${new Date().getMinutes()}`,
    searchType: 'tabSeason',
    isdefaultset: false
  }),
  created() {},
  mounted() {
    this.today = this.utils.getLocalDate();
    this.init();
  },
  props: {
    festival: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  watch: {
    searchType(value) {
      if (value == 'tabSeason' && this.eventSelect && this.eventSelect.start_date
        && (this.eventSelect.start_date.substr(0, 10) != this.startEventDate
        || this.eventSelect.end_date.substr(0, 10) != this.endEventDate)) {
          this.yearSelect = this.yearItems[0];
      }
    },
    yearSelect() {
      if (isNaN(this.yearSelect)) {
        this.eventItems = ['กำหนดเอง'];
        this.eventSelect = this.eventItems[0];
      }
      else {
        const scope = this;
        const url = `${process.env.VUE_APP_SERVICE_API_URL}/service/get/festival/${this.yearSelect -
          543}`;
        this.axios
          .get(url)
          .then(response => {
            const fesdata = response.data.data;
            if (fesdata.length > 0) {
              scope.eventItems = fesdata;
              if (scope.festival && !scope.isdefaultset) {
                const ev = scope.eventItems.filter(member => {
                  return member.id === scope.festival.id;
                })[0];
                if (ev) {
                  scope.eventSelect = ev;
                  scope.isdefaultset = true;
                }
                else {
                  scope.eventSelect = fesdata[0];
                }
              }
              else {
                scope.eventSelect = fesdata[0];
              }
            } else {
              scope.eventItems = [];
              scope.eventSelect = {};
            }
          })
          .catch(error => {
            scope.eventItems = [];
            console.error(error);
          });
      }
    },
    eventSelect() {
      if (this.$refs.startEventDate && this.$refs.endEventDate && this.eventSelect && this.eventSelect.start_date && this.isdefaultset) {
        this.$refs.startEventDate.setDefaultData(this.eventSelect.start_date.substr(0, 10));
        this.$refs.endEventDate.setDefaultData(this.eventSelect.end_date.substr(0, 10));
        this.$refs.compareStartEventDate.setDefaultData(this.eventSelect.compare_start_date.substr(0, 10));
        this.$refs.compareEndEventDate.setDefaultData(this.eventSelect.compare_end_date.substr(0, 10));
      }
      if (this.eventSelect && this.eventSelect.start_date) {
        this.filterdate = this.getLastWeekPeriodDateWithText(
          this.eventSelect.start_date,
          this.eventSelect.end_date
        );
      }
    }
  },
  methods: {
    init() {
      this.filterdate = this.getLastWeekPeriodDateWithText(
        this.festival.start_date,
        this.festival.end_date
      );
      this.getYearLists();
      this.getProvince();
      this.getvehicle();
    },
    getLastWeekPeriodDateWithText(from, to) {
      if (!from) {
        from = this.startEventDate;
      }
      if (!to) {
        to = this.endEventDate;
      }
      if (from && to && from.substr(0, 10) == to.substr(0, 10)) {
        return `วันที่ ${this.utils.formatToDateThai(from)}`;
      }
      return `วันที่ ${this.utils.formatToDateThai(from)} ถึง วันที่ ${this.utils.formatToDateThai(to)}`;
    },
    onSearchClick() {
      if (this.searchType === 'tabPeriod' || !this.eventSelect.start_date) {
        this.$emit('filterChange', {
          search: this.searchType,
          start_date: this.startEventDate.substring(0, 10),
          end_date: this.endEventDate.substring(0, 10),
          compare_start_date: this.compareStartEventDate.substring(0, 10),
          compare_end_date: this.compareEndEventDate.substring(0, 10),
          report_date: this.reportDate.substring(0, 10),
          report_time: this.reportTime,
          province: this.provinceSelect,
          vehicle: this.vehicleSelect,
          isBMTA: this.isBMTA
        });
      } else if (this.eventSelect) {
        const festival = this.eventSelect;
        this.$emit('filterChange', {
          search: this.searchType,
          // year: this.yearSelect,
          id: festival.id,
          start_date: festival.start_date.substr(0, 10),
          end_date: festival.end_date.substr(0, 10),
          compare_start_date: festival.compare_start_date
            ? festival.compare_start_date.substr(0, 10)
            : null,
          compare_end_date: festival.compare_end_date
            ? festival.compare_end_date.substr(0, 10)
            : null,
          isBMTA: this.isBMTA
        });
      } else if (this.yearSelect !== '') {
        const year = this.yearSelect - 543;
        this.filterdate = this.getLastWeekPeriodDateWithText(`${year}-01-01`, `${year}-12-31`);
        this.$emit('filterChange', {
          start_date: `${year}-01-01`,
          end_date: `${year}-12-31`,
          isBMTA: this.isBMTA
        });
      }
    },
    getYearLists() {
      const scope = this;
      const url = `${process.env.VUE_APP_SERVICE_API_URL}/options/ref/budget_year`;
      this.axios
        .get(url)
        .then(response => {
          if (response.status === 200 && response.data.data) {
            scope.yearItems = response.data.data.map(Number);
            scope.yearItems.unshift('กำหนดเอง');
            if (scope.festival) {
              scope.yearSelect = parseInt(scope.festival.end_date.substr(0, 4), 10) + 543;
            }
            else {
              scope.yearSelect = scope.yearItems[0];
            }
          }
        })
        .catch(error => {
          scope.yearItems = [];
          console.log(error);
        });
    },
    getProvince() {
      const scope = this;
      const url = `${process.env.VUE_APP_SERVICE_API_URL}/options/ref/province`;
      this.axios
        .get(url)
        .then(response => {
          if (response.status === 200 && response.data.data) {
            scope.provinceItems = response.data.data;
            scope.provinceItems.unshift({ id: 0, name: 'เลือกทุกจังหวัด' });
          }
        })
        .catch(error => {
          scope.provinceItems = [];
          console.log(error);
        });
    },
    getvehicle() {
      const scope = this;
      const url = `${process.env.VUE_APP_SERVICE_API_URL}/options/ref/vehicle`;
      this.axios
        .get(url)
        .then(response => {
          if (response.status === 200 && response.data.data) {
            scope.vehicleItems = response.data.data;
            scope.vehicleItems.unshift({ id: 0, name: 'เลือกทุกประเภท' });
          }
        })
        .catch(error => {
          scope.vehicleItems = [];
          console.log(error);
        });
    },
    getEventLists() {
      const scope = this;
      const url = `${process.env.VUE_APP_SERVICE_API_URL}/options/ref/event`;

      this.axios
        .get(url)
        .then(response => {
          if (response.status === 200 && response.data.data) {
            scope.eventItems = response.data.data;
          }
        })
        .catch(error => {
          scope.eventItems = [];
          console.log(error);
        });
    },
    changeDate(period, isCompare) {
      if (isCompare) {
        if (period) {
          if (period.startDate != this.compareStartEventDate) {
            this.$refs.compareStartEventDate.setDefaultData(period.startDate);
          }
          if (period.endDate != this.compareEndEventDate) {
            this.$refs.compareEndEventDate.setDefaultData(period.endDate);
          }
        }
      }
      else {
        if (period) {
          if (period.startDate != this.startEventDate) {
            this.$refs.startEventDate.setDefaultData(period.startDate);
          }
          if (period.endDate != this.endEventDate) {
            this.$refs.endEventDate.setDefaultData(period.endDate);
          }
        }
        this.filterdate = this.getLastWeekPeriodDateWithText(
          this.startEventDate,
          this.endEventDate
        );
      }
    }
  },
  computed: {
    isAdmin() {
      return ['ADMIN', 'SYSTEM'].indexOf(localStorage.getItem('role')) != -1;
    }
  }
};
</script>

<style lang="scss" scoped>
.brightgrey-bg {
  background-color: var(--v-brightgrey-base);
}
.filter-menu {
  overflow: auto;
}
</style>
